import * as React from 'react';
import styled from 'styled-components';
import { IDate, DateTime, IDateFormat } from '@agilepoint/utils-date-time';
import { IBaseComponentProps } from '../../types';
import { Day, IDateInfo, CalendarView } from '../../calendar/calendar-types';
import { Calendar } from '../../calendar/calendar';
import { selectThemeSemantics } from '../../../styling';

interface IDateRangeCalendar extends IBaseComponentProps<HTMLDivElement> {
    hideDateFromOtherMonth?: boolean;
    maxDate?: IDate;
    minDate?: IDate;
    weekStartDay?: Day;
    format?: IDateFormat;
    value?: DateTime[];
    firstCalendarView: CalendarView;
    showWeekNumber?: boolean;
    secondCalendarView: CalendarView;
    onChange(value: Date[]): void;
    onDateCellMouseOver(view: IDateInfo): void;
    onFirstCalendarViewChange(view: CalendarView): void;
    onSecondCalendarViewChange(view: CalendarView): void;
}

const DateRangePickerFirstCalendar = styled(Calendar).attrs({
    className: String('ap-dateRangePicker-firstCalendar')
})`
    border-right-style: solid;
    border-right-width: ${selectThemeSemantics(({ gap }) => gap.xs)};
    border-right-color: ${({ theme: { dateRangePicker: { colors } } }) => colors.sectionDividerColor};
`;

export function DateRangeCalendar(props: IDateRangeCalendar) {
    const {
        minDate, maxDate, weekStartDay, value, format, hideDateFromOtherMonth,
        firstCalendarView, secondCalendarView, onChange, showWeekNumber,
        onFirstCalendarViewChange, onSecondCalendarViewChange, onDateCellMouseOver
    } = props;

    return (
        <div className="ap-dateRangePicker">
            <DateRangePickerFirstCalendar
                hideDateFromOtherMonth={hideDateFromOtherMonth}
                onChange={onChange}
                onDateCellMouseOver={onDateCellMouseOver}
                onViewChange={onFirstCalendarViewChange}
                endYear={secondCalendarView.year}
                value={value}
                format={format}
                maxDate={maxDate}
                minDate={minDate}
                weekStartDay={weekStartDay}
                selectionMode="range"
                showWeekNumber={showWeekNumber}
                view={firstCalendarView} />
            <Calendar
                hideDateFromOtherMonth={hideDateFromOtherMonth}
                className="ap-dateRangePicker-secondCalendar"
                onChange={onChange}
                onDateCellMouseOver={onDateCellMouseOver}
                onViewChange={onSecondCalendarViewChange}
                startYear={firstCalendarView.year}
                value={value}
                format={format}
                maxDate={maxDate}
                minDate={minDate}
                weekStartDay={weekStartDay}
                selectionMode="range"
                showWeekNumber={showWeekNumber}
                view={secondCalendarView} />
        </div>
    );
}
